<template>
    <div id="basic_navigation_header">
        <div v-if="headerImage">
            <img src="/images/logo.png" style="position: absolute; top: 10px; margin: 5px;" width="15%">
            <img :src="`/images/` + headerImage" width="100%">
        </div>
        <div id="nav">
            <v-layout wrap>
                <v-flex v-for="(item,i) in pages" :key="i">
                    <router-link :to="item.link" mx-2>{{item.name}}</router-link>
                </v-flex>
                <v-flex v-if="loginActive">
                    <router-link to="/ticketing_group">Ticketing Group</router-link>
                </v-flex>
                <v-flex v-if="loginActive">
                    <router-link to="/riwayat_pemesanan">Riwayat Pemesanan</router-link>
                </v-flex>
                <v-flex v-if="loginActive">
                    <a class="navigasi" @click.prevent="logout">Logout</a>
                </v-flex>
                <v-flex v-if="!loginActive">
                    <router-link to="/login">Login</router-link>
                </v-flex>
            </v-layout>
        </div>
    </div>
</template>
<style scoped lang="scss">
    #basic_navigation_header {
        background-color: white;
    }
    #nav {
        background-color: white;
        text-align: center;
        padding: 30px;
        a {
            font-size: 18pt;
            text-decoration: none;
            font-weight: bold;
            color: #2c3e50;
            padding: 0 5px;
            &.router-link-exact-active {
                color: #11E7E7;
            }
        }

        a:hover {
            cursor: pointer;
        }
    }
</style>
<script>
    import store from '@/store/index';

    export default {
        props: ['headerImage'],
        computed: {
            loginActive() {
                return store.getters['auth/check'];
            }
        },
        methods: {
            async logout() {
                // Log out the user.
                await this.$store.dispatch('auth/logout');

                // Redirect to login.
                this.$router.push({name: 'home'});
            }
        },
        data: () => ({
            pages: [
                { name: "Home", link: "/" },
                { name: "About", link: "/about" },
                { name: "Wahana", link: "/wahana" },
                { name: "Ticketing", link: "/ticketing" },
                // { name: "Activities", link: "/activities" },
                // { name: "Raport", link: "/raport" },
                // { name: "CCTV", link: "/cctv" },
            ]
        })
    }
</script>